import React from "react";

export default () => {
  return (
    <React.Fragment>
      <rect x="9" y="15" rx="4" ry="4" width="25" height="25" />
      <rect x="55" y="20" rx="3" ry="3" width="220" height="4" />
      <rect x="55" y="30" rx="3" ry="3" width="200" height="4" />
    </React.Fragment>
  );
};
